import React from 'react';
import * as production from 'react/jsx-runtime';
import rehypeReact from 'rehype-react';
import { unified } from 'unified';
import {
  figureRegular,
  figureExtraWide,
  figureLeftAligned,
  figureFullWidth,
  dividerParaWideLine,
  dividerThreeDots,
  dividerFigureRegular,
  chartDesktopRegular,
  chartDesktopExtraWide,
  chartDesktopLeftAligned,
  chartDesktopFullWidth,
  chartMobile,
  caseStudy,
  KeyFindings,
  videoRegular,
  videoExtraWide,
  videoLeftAligned,
  videoFullWidth,
  footnote,
  RelatedArticle,
} from './contentComponents/ContentComponents';
import { ImageGallery } from './contentComponents/ImageGallery';
import { singleCaption } from './contentComponents/SingleCaption';
import { ColorBackground } from './contentComponents/ColorBackground';
import { Slideshow } from './contentComponents/Slideshow';

const processor = unified().use(rehypeReact, {
  ...production,
  components: {
    'figure-regular': figureRegular,
    'figure-extra-wide': figureExtraWide,
    'figure-left-aligned-out': figureLeftAligned,
    'figure-full-width': figureFullWidth,
    'divider-three-dots': dividerThreeDots,
    'divider-para-wide-line': dividerParaWideLine,
    'divider-figure-regular': dividerFigureRegular,
    'chart-desktop-regular': chartDesktopRegular,
    'chart-desktop-extra-wide': chartDesktopExtraWide,
    'chart-desktop-left-aligned-out': chartDesktopLeftAligned,
    'chart-desktop-full-width': chartDesktopFullWidth,
    'chart-mobile': chartMobile,
    'case-study': caseStudy,
    'key-findings': KeyFindings,
    'video-regular': videoRegular,
    'video-extra-wide': videoExtraWide,
    'video-left-aligned-out': videoLeftAligned,
    'video-full-width': videoFullWidth,
    'image-gallery': ImageGallery,
    fn: footnote,
    'single-caption': singleCaption,
    'related-article': RelatedArticle,
    'color-background': ColorBackground,
    'gecko-slideshow': Slideshow,
  },
});

export const HTMLContent = ({ content, className }) => {
  return <div className={className}>{processor.stringify(content)}</div>;
};
